// Investiture
import React from 'react';
import KannadaRajyotsava2025 from '../views/KannadaRajyotsava2025';


const InvestiturePage = () => {
  return <KannadaRajyotsava2025 />;
};

export default InvestiturePage;
